<div class="submenu" *ngIf="!model.workshop && model.project && model.project.id && shouldShow()">
    <mat-icon routerLink="/{{env.links.viewCatalog}}/{{model.project.id}}">chevron_left</mat-icon>
    <div class="title" *ngIf="model.concept && model.concept.name">
        {{model.concept.name}}
    </div>
</div>
